import { create } from 'zustand'
import { ReactNode } from 'react'

export type DialogType = 'confirmation' | 'info' | 'warning' | 'error' | 'success'

export interface DialogAction {
  label: string
  onClick: () => void
  color?: 'inherit' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
  variant?: 'text' | 'outlined' | 'contained'
  autoFocus?: boolean
}

interface DialogState {
  open: boolean
  title: string
  message: string | ReactNode
  type: DialogType
  actions: DialogAction[]
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'

  // Actions
  openDialog: (
    title: string,
    message: string | ReactNode,
    actions: DialogAction[],
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
    type?: DialogType,
  ) => void
  closeDialog: () => void
}

export const useDialogStore = create<DialogState>((set) => ({
  open: false,
  title: '',
  message: '',
  type: 'confirmation',
  actions: [],
  size: 'sm',

  openDialog: (title, message, actions, size = 'sm', type = 'confirmation') =>
    set({
      open: true,
      title,
      message,
      actions,
      size,
      type,
    }),

  closeDialog: () => set({ open: false }),
}))
